import React, { useMemo, useRef, useState, useEffect } from "react";
import withRouter from "../../../components/Common/withRouter";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  UncontrolledTooltip,
  Badge,
  Modal,
  ModalHeader,
  ModalBody,
  FormFeedback,
  Label,
  Input,
  CardTitle,
} from "reactstrap";
import TableContainer from "../../../components/Common/TableContainer";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import MediaModel from "../MediaUpload/MediaModel";
import toast from "react-hot-toast";

const DisplayName = () => {
  const baseurl = process.env.REACT_APP_BASE_URL;
  const imgurl = process.env.REACT_APP_IMAGE_URL;
  const imageInputRef = useRef(null);
  const [DisplayNameData, setDisplayNameData] = useState([]);
  const [error, setError] = useState(null);
  const [modal, setModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [uploadedImages, setUploadedImages] = useState(null);
  const [imageModel, setImageModel] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [editData, setEditData] = useState({
    id: "",
    displayname: "",
    status: "",
    image: "",
    meta_title: "",
    meta_description: "",
    meta_keywords: "",
  });

  const fetchDisplayNameData = async () => {
    try {
      setError(null);
      const response = await fetch(`${baseurl}/admin/master/displaynames`);
      if (!response.ok) throw new Error("Network response was not ok");
      const data = await response.json();
      setDisplayNameData(data);
    } catch (error) {
      setError(error.message);
    }
  };

  useEffect(() => {
    fetchDisplayNameData();
  }, []);

  const toggleModal = () => setModal(!modal);

  const handleEditClick = (rowData) => {
    setEditData(rowData);
    setIsEdit(true);
    if (rowData.image) {
      setUploadedImages([imgurl + rowData.image]);
    } else {
      setUploadedImages(null);
    }
    toggleModal();
  };

  const toggleImageModal = () => {
    setImageModel(!imageModel);
    setSelectedImage([]);
  };

  const handleUploadImage = (image) => {
    if (image) {
      console.log(image[0])
      setUploadedImages([imgurl + image[0].fileurl]);
      validation.setFieldValue("image", image[0].fileurl);
    }
    toggleImageModal();
    setSelectedImage(null);
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const newImage = Object.assign(file, {
        preview: URL.createObjectURL(file),
      });
      setUploadedImages([newImage]);
    }
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: editData.id || "",
      displayname: editData.displayname || "",
      status: editData.status || "",
      image: editData.image || "",
      meta_title: editData.meta_title || "",
      meta_description: editData.meta_description || "",
      meta_keywords: editData.meta_keywords || "",
    },
    validationSchema: Yup.object({
      displayname: Yup.string().required("Please enter a display name"),
      status: Yup.string().required("Please select a status"),
      meta_title: Yup.string().required("Meta title is required"),
      image: Yup.mixed().test(
        "fileSelected",
        "Please select an image",
        () => uploadedImages && uploadedImages.length > 0
      ),
      meta_description: Yup.string()
        .required("Meta description is required")
        .max(180, "Meta description cannot exceed 180 characters"),
      meta_keywords: Yup.string().required("Meta keywords are required"),
    }),
    onSubmit: async (values) => {
      try {
        const { id, displayname, status,meta_title,meta_description,meta_keywords,image } = values;
        const response = await fetch(`${baseurl}/admin/master/displaynames/${id}`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            displayname,
            image,
            status,
            meta_title,
            meta_description,
            meta_keywords,
            
          }),
        });

        if (!response.ok) throw new Error("Error updating Display name");

        toast.success("Display name updated successfully!");
        fetchDisplayNameData();
        toggleModal();
      } catch (error) {
        console.error(error);
        toast.error(error.message);
      }
    },
  });

  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        Cell: ({ value }) => <div className="text-body fw-bold">{value}</div>,
      },
      {
        Header: "Name",
        accessor: "displayname",
        filterable: true,
      },
      {
        Header: "Image",
        accessor: "image",
        Cell: ({ value }) => (
          <div className="text-center">
            {value && <img className="avatar-md" src={`${imgurl}${value}`} alt="" />}
          </div>
        ),
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value }) => (
          <Badge color={value === "Active" ? "success" : "danger"}>
            {value.charAt(0).toUpperCase() + value.slice(1)}
          </Badge>
        ),
      },
      {
        Header: "Action",
        Cell: ({ row }) => (
          <div className="d-flex gap-3">
            <Link
              to="#"
              className="text-success"
              onClick={() => handleEditClick(row.original)}
            >
              <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
              <UncontrolledTooltip placement="top" target="edittooltip">
                Edit
              </UncontrolledTooltip>
            </Link>
          </div>
        ),
      },
    ],
    []
  );

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Display Name" breadcrumbItem="Manage Display Name" />
        <Row>
          <Col lg="12">
            <Card>
              <CardBody>
                <TableContainer
                  columns={columns}
                  data={DisplayNameData}
                  isGlobalFilter
                  customPageSize={10}
                  className="custom-header-css"
                />
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Modal isOpen={modal} toggle={toggleModal} size="lg" scrollable>
          <ModalHeader toggle={toggleModal}>Edit</ModalHeader>
          <ModalBody>
            <form onSubmit={validation.handleSubmit}>
              <Row>
                <Col md={6}>
                  <Label>Display Name</Label>
                  <Input
                    name="displayname"
                    value={validation.values.displayname}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    invalid={!!validation.errors.displayname && validation.touched.displayname}
                  />
                  <FormFeedback>{validation.errors.displayname}</FormFeedback>
                </Col>

                <Col md={6}>
                  <Label>Status</Label>
                  <Input
                    type="select"
                    name="status"
                    value={validation.values.status}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    invalid={!!validation.errors.status && validation.touched.status}
                  >
                    <option value="">Select</option>
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </Input>
                  <FormFeedback>{validation.errors.status}</FormFeedback>
                </Col>

                <Col md={12} className="mt-3">
                  <Label>Image</Label>
                  <div className="custom-file-button" onClick={toggleImageModal}>
                    <i className="bx bx-cloud-upload me-2" style={{ fontSize: "25px" }}></i>
                    Choose File
                  </div>
                  {validation.errors.image && validation.touched.image && (
                    <FormFeedback className="d-block">{validation.errors.image}</FormFeedback>
                  )}
                  {uploadedImages && (
                    <Card className="mt-2 border">
                      <CardBody>
                        <Row className="align-items-center">
                          <Col>
                            <img
                              src={uploadedImages}
                              alt="Preview"
                              className="avatar-md rounded bg-light"
                            />
                          </Col>
                          <Col className="text-end">
                            <Button
                              size="sm"
                              color="danger"
                              onClick={() => setUploadedImages(null)}
                            >
                              Delete
                            </Button>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  )}
                </Col>

                <Col md={12} className="mt-3">
                  <Card>
                    <div className="card-header">
                      <CardTitle>Meta Data</CardTitle>
                      <p className="m-0">Fill all information below</p>
                    </div>
                    <CardBody>
                      <Row>
                        <Col md={6}>
                          <Label>Meta Title</Label>
                          <Input
                            name="meta_title"
                            value={validation.values.meta_title}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            invalid={!!validation.errors.meta_title && validation.touched.meta_title}
                          />
                          <FormFeedback>{validation.errors.meta_title}</FormFeedback>
                          <Label className="mt-3">Meta Keywords</Label>
                          <Input
                            name="meta_keywords"
                            value={validation.values.meta_keywords}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            invalid={
                              !!validation.errors.meta_keywords && validation.touched.meta_keywords
                            }
                          />
                          <FormFeedback>{validation.errors.meta_keywords}</FormFeedback>
                        </Col>
                        <Col md={6}>
                          <Label>Meta Description</Label>
                          <textarea
                            rows="5"
                            name="meta_description"
                            className="form-control"
                            maxLength="180"
                            value={validation.values.meta_description}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                          />
                          <div className="text-muted small">
                            {validation.values.meta_description.length}/180 characters
                          </div>
                          {validation.errors.meta_description && validation.touched.meta_description && (
                            <div className="text-danger">{validation.errors.meta_description}</div>
                          )}
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
              <div className="text-end">
                <Button color="success" type="submit">
                  Save
                </Button>
              </div>
            </form>
          </ModalBody>
        </Modal>

        <MediaModel
          imageModel={imageModel}
          toggleModal={toggleImageModal}
          handleUploadImage={handleUploadImage}
          selectedImage={selectedImage}
          setSelectedImage={setSelectedImage}
        />
      </Container>
    </div>
  );
};

export default withRouter(DisplayName);
